import type { PropsWithChildren } from 'react'

import { As, Button, ButtonProps } from '@chakra-ui/react'
import { useAtom } from 'jotai'

import { claimSpiritMachineAtom } from '../atoms/claimSpiritMachineAtom'

interface ClaimSpiritButtonProps extends Omit<ButtonProps, "as" | "onClick" | "disabled"> {
  as?: any
}

function makeClaimSpiritMachineButton(name: string, action: string, loadingState: string, defaultText: string) {
  const highOrderComponent = ({ children, ...props }: PropsWithChildren<ClaimSpiritButtonProps>) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [machine, send] = useAtom(claimSpiritMachineAtom)
    return (
      <Button
        {...props}
        isLoading={machine.matches(loadingState)}
        disabled={!machine.can(action)}
        onClick={() => send({type: action})}
      >
        {children || defaultText}
      </Button>
    )
  }
  highOrderComponent.displayName = `${name}Button`
  return highOrderComponent
}

export const CreateSpiritButton = makeClaimSpiritMachineButton(
  'CreateSpirit',
  'createSpirit',
  'signedIn.creatingSpirit',
  'Create Spirit'
)

export const UpdateSpiritButton = makeClaimSpiritMachineButton(
  'UpdateSpirit',
  'updateSpirit',
  'signedIn.updatingSpirit',
  'Update Spirit'
)

export const ClaimSpiritButton = makeClaimSpiritMachineButton(
  'ClaimSpirit',
  'claimSpirit',
  'signedIn.claimingSpirit',
  'Claim Spirit'
)

// NOTE: this button only for testing or debugging environment.
export const RemoveSpiritButton = makeClaimSpiritMachineButton(
  'RemoveSpirit',
  'removeSpirit',
  'signedIn.removingSpirit',
  'Remove Spirit'
)

export const RefreshButton = makeClaimSpiritMachineButton(
  'Refresh',
  'refresh',
  'signedIn.checkingState',
  'Refresh'
)
